import React, { } from "react";
import './style.scss'
import { dummyData } from './dummydata'
import {
    BarChart, Bar, LabelList, ReferenceLine, ResponsiveContainer, Cell, XAxis, YAxis, Tooltip,
} from 'recharts';

function WeeklyReport(props) {
    const CustomizedLabel = (props) => {
        const { x, y, stroke, value, width } = props;
        return <g >
            <text x={(x + width / 2) - 12}
                y={value!==null &&(value.toFixed(0)) === 0 ? y - 15 : y} dy={Math.sign(value) === 1 ? -4 : 12} fill={stroke} fontSize={12} >
                {value !== null ? `${ (value.toFixed(0)).toLocaleString()}%` : ''}
            </text></g>
    }

    const CustomizedTick = (props) => {
        const { x, y } = props;
        return (
            <g transform={`translate(${x},${y})`} >
                <text marginBottom="20px" x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">wk{props.payload.value}</text>
            </g>
        )

    }

    function renderTooltip(item, label) {
        return (
            <div style={{
                backgroundColor: 'white',
                height: '50px',
                padding: '10px',
                alignContent: 'center',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <span style={{ color: "black" }}>
                    WeekNo : {" "}{item?.payload?.length ? item?.payload[0]?.payload?.WeekNo : ''}
                </span>
                <span style={{ color: "black" }}>
                    {label === "accuracy" && `Accuracy : ${" "}${item?.payload?.length ? item?.payload[0]?.payload?.Accuracy.toFixed(0).toLocaleString() : ''}%`}
                    {label === "bias" && `Bias : ${" "}${item?.payload?.length ? item?.payload[0]?.payload?.Bias.toFixed(0).toLocaleString() : ''}%`}
                </span>
            </div>
        )
    }

    return (
        <>
            <div className="graph-main">
                <div><p style={{
                    textAlign: 'left',
                    margin: '0px',
                    fontSize: "18px",
                    fontFamily: 'Source Sans Pro',
                    fontWeight: 'bold'
                }}>Forecast Accuracy Weekly</p></div>
                <ResponsiveContainer width='100%' height={450}>
                    <BarChart
                        barGap={5}
                        barCategoryGap={2}
                        data={props.dummyData}
                        margin={{
                            top: 15, right: 20, left: 20, bottom: 25,
                        }} >
                        <XAxis axisLine={{ stroke: 'red' }}
                            tickLine={false}
                            tick={<CustomizedTick />}
                            dataKey="WeekNo"
                        // tickFormatter={(label) => `wk${label}`} 
                        />
                        <YAxis height={120}
                            axisLine={{ stroke: "#eaf0f4" }}
                            tickLine={false}
                            tickFormatter={(label) => `${label}%`} />
                        <Tooltip content={e => renderTooltip(e, "accuracy")} />
                        {/* <Legend /> */}
                        <Bar dataKey="Accuracy"
                            barSize={14}
                        >
                            <LabelList content={<CustomizedLabel myProps={props.dummyData} />} position="top" />
                            {props.dummyData.map((entry, index) => (
                                <Cell fill={entry.Accuracy < 60 ? dummyData.colorData[1]
                                    : entry.Accuracy >= 60 && entry.Accuracy <= 80 ? dummyData.colorData[0] :
                                        dummyData.colorData[2]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
                <div className='weekly-bais-bottom-main'>
                    <div className='weekly-accuracy-bottom-1'>
                    </div><p style={{ fontSize: '12px' }}>{`<60%`}</p>
                    <div className='weekly-accuracy-bottom-2'>
                    </div><p style={{ fontSize: '12px' }}>60% - 80%</p>
                    <div className='weekly-accuracy-bottom-3'>
                    </div><p style={{ fontSize: '12px' }}>{`>80%`}</p>
                </div>
            </div>
            <div className="graph-main">
                <div><p style={{
                    textAlign: 'left',
                    fontFamily: 'Source Sans Pro',
                    fontWeight: 'bold',
                    margin: '0px',
                    fontSize: "18px",
                }}>Forecast Bias Weekly</p></div>
                <ResponsiveContainer width='100%' height={420}>
                    <BarChart
                        barSize={14}
                        barGap={2}
                        barCategoryGap={2}
                        data={props.dummyData}
                        margin={{
                            top: 5, right: 35, left: 35, bottom: 25,
                        }}
                    >

                        <XAxis
                            axisLine={{ stroke: "#eaf0f4" }}
                            tickLine={false}
                            tick={<CustomizedTick />}
                            dataKey="WeekNo"
                        // tickFormatter={(label) => `wk${label}`} tick={{ angle: 45 }}
                        />
                        <YAxis axisLine={{ stroke: "#eaf0f4" }}
                            tickLine={false}
                            tickFormatter={(label) => `${label}%`} />
                        <Tooltip content={e => renderTooltip(e, "bias")} />
                        <ReferenceLine x={0} stroke='#eaf0f4' />
                        <Bar dataKey="Bias">
                            <LabelList content={<CustomizedLabel myProps={props.dummyData} />}
                            />
                            {props.dummyData.map((entry, index) => (
                                <Cell fill={Math.sign(entry.Bias) === 1 ? dummyData.colorData[3]
                                    : dummyData.colorData[4]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
                <div className='weekly-bais-bottom-main'>
                    <div className='weekly-bais-bottom-postive'>
                    </div><p style={{ fontSize: '12px' }}>Positive</p>
                    <div className='weekly-bais-bottom-negative'>
                    </div><p style={{ fontSize: '12px' }}>Negative</p>
                </div>
            </div>
        </>
    )
}

export default WeeklyReport;